module.exports = __webpack_public_path__ + "static/img/849_phase_function_Paper_PointsHejduk_Prediction.8265cbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/849_phase_function_Paper_PointsHejduk_Prediction.png
// module id = S98Y
// module chunks = 0